import React, { useEffect, useState, useRef } from "react";
import Common from "../../helper/common";
import AdvanceTable from "../../components/advanceTable";
import { ViewDateTimeFormat } from "../../constants/appConstant";
import {
  SearchTypeEnum,
  ContactusStatusEnum,
} from "../../constants/appConstant";
import DialogModal from "../../components/partials/modal/dialogModal";
import { Formik } from "formik";
import * as yup from "yup";
import {
  FormikTextArea,
  FormikSelect,
} from "../../components/formik-components";
import { Button } from "../../components/ui/button";
import toast from "react-hot-toast";
import { AppSelect } from "../../components/appComponents";

const ContactUs = () => {
  const [data, setData] = useState({});
  const [showComment, setShowComment] = useState(false);
  const [refId, setRefId] = useState(null);
  const [refComment, setRefComment] = useState(null);
  const [refStatus, setRefStatus] = useState(null);
  const [refOrignalStatus, setRefOrignalStatus] = useState(null);
  const [paramStatus, setParamStatus] = useState(null);
  const dropdownFormikRef = useRef(null);

  const formStatusValidations = yup.object({
    comment: yup
      .string()
      .trim()
      .min(3)
      .max(150)
      .required("Comment is Required"),
  });

  useEffect(() => {
    getData(1);
  }, []);

  useEffect(() => {
    getData(1);
  }, [paramStatus]);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    const response = await Common.ApiService.getInstance().request(
      "ContactUsList",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        recordsToDisplay,
        status: paramStatus,
      },
      "Post"
    );
    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          createdOn: `${Common.moment(item.createdOn).format(
            ViewDateTimeFormat
          )}`,
          statusDdl: renderStatusDdl(item.id, item.status, item.comment),
          comment: renderEditComment(item.id, item.status, item.comment),
        })),
      };
      setData(obj);
    }
  };

  const changeStatus = async (d) => {
    if (!refStatus) {
      toast.error(`status Required`);
      return;
    }
    if (refStatus != ContactusStatusEnum.New && !d.comment) {
      toast.error(`You must write a comment`);
      return;
    }

    setShowComment(false);
    let data = {
      ...d,
      id: +refId,
      status: +refStatus,
    };

    let resp = await Common.ApiService.getInstance().request(
      "UpdateContactUsStatus",
      data,
      "Patch"
    );
    Common.SweetAlert.alert(resp.message, "success");
    setTimeout(() => {
      getData();
      resetRefs();
    }, 500);
  };

  const handleModalClose = () => {
    if (dropdownFormikRef.current) {
      dropdownFormikRef.current.setFieldValue("status", refOrignalStatus);
      dropdownFormikRef.current.setFieldTouched("status", false);
    }
    resetRefs();
    setShowComment(false);
  };

  const resetRefs = () => {
    setRefId(null);
    setRefComment(null);
    setRefStatus(null);
    setRefOrignalStatus(null);
  };

  const _renderStatusChange = () => (
    <div>
      <Formik
        onSubmit={changeStatus}
        validationSchema={formStatusValidations}
        enableReinitialize
        initialValues={{
          comment: refComment,
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formikProps) => (
          <>
            <div>
              <FormikTextArea
                formikProps={formikProps}
                name={"comment"}
                placeholder={"Type..."}
                type={"textarea"}
                label={"Comment"}
                maxLength={150}
              />
            </div>

            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <Button
                color="success"
                onClick={(e) => {
                  e.preventDefault();
                  formikProps.handleSubmit();
                }}
                className="shadow-md mr-3"
              >
                Save
              </Button>

              <Button
                color="secondary"
                className="secondary"
                onClick={handleModalClose}
              >
                Close
              </Button>
            </div>
          </>
        )}
      </Formik>
    </div>
  );

  const renderEditComment = (id, status, comment) => {
    if (!comment) return <span></span>;

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span>{comment}</span>
        <span
          onClick={() => {
            setRefId(id);
            setRefComment(comment);
            setRefStatus(status);
            setShowComment(true);
          }}
          style={{
            marginLeft: "10px",
            cursor: "pointer",
            color: "#2b2b8a",
            fontSize: "16px",
          }}
          title="Edit Comment"
        >
          ✏️
        </span>
      </div>
    );
  };

  const renderStatusDdl = (id, originalStatus, comment) => {
    return (
      <Formik
        initialValues={{ status: originalStatus }}
        onSubmit={() => {}}
        enableReinitialize
      >
        {(formikProps) => {
          dropdownFormikRef.current = formikProps;

          return (
            <FormikSelect
              formikProps={formikProps}
              name="status"
              data={Common.Utility.enumToArray(ContactusStatusEnum).map(
                (item) => ({
                  ...item,
                  disabled: item.id == ContactusStatusEnum.New,
                })
              )}
              placeholder={"Select Status"}
              onChange={(e) => {
                setRefOrignalStatus(originalStatus);
                if (e !== originalStatus) {
                  setRefId(id);
                  setRefComment(comment);
                  setRefStatus(e);

                  if (e !== ContactusStatusEnum.New) {
                    setShowComment(true);
                  } else {
                    changeStatus({ comment });
                  }
                }
              }}
            />
          );
        }}
      </Formik>
    );
  };

  let columns = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    { title: "Image", type: "image", isVisible: true, key: "image" },
    { title: "Name", type: "text", isVisible: true, key: "name" },
    { title: "Status", type: "html", isVisible: true, key: "statusDdl" },
    {
      title: "Comment",
      type: "html",
      style: { minWidth: "300px", whiteSpace: "normal" },
      isVisible: true,
      key: "comment",
    },
    { title: "Email", type: "text", isVisible: true, key: "email" },
    {
      title: "Country Code",
      type: "text",
      isVisible: true,
      key: "countryCode",
    },
    { title: "Phone", type: "text", isVisible: true, key: "phone" },
    {
      title: "message",
      type: "text",
      style: { 
        minWidth: "200px",
        maxWidth: "300px",
        whiteSpace: "normal",
        overflow: "auto",
        scrollbarWidth: "thin", 
        "&::-webkit-scrollbar": { 
          width: "1px",
          height: "0px"
        }
      },
      isVisible: true,
      key: "message",
    },
    { title: "Created Date", type: "text", isVisible: true, key: "createdOn" },
  ];

  return (
    <>
      <DialogModal
        title={""}
        open={showComment}
        setOpen={(val) => {
          setShowComment(val);
          if (!val) handleModalClose();
        }}
        Child={_renderStatusChange}
      />

      <div className="md:grid md:grid-cols-5 grid grid-cols-2 gap-x-2 ">
        <AppSelect
          value={paramStatus}
          onChange={setParamStatus}
          placeholder="Select Status"
          label="Status"
          data={[
            { id: null, name: "Select" },
            ...Common.Utility.enumToArray(ContactusStatusEnum),
          ]}
          className="mb-3 col-span-1"
        />
      </div>
      {data?.data && (
        <AdvanceTable
          title={"Contact Us"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          showPagination
          search={SearchTypeEnum.Server_Search}
        />
      )}
    </>
  );
};

export default ContactUs;
